var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.803119 0 0 0.803119 -0.302887 -0.935348)",
    stroke: "#000",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial",
    fontSize: 20,
    id: "svg_1",
    y: 20.69932,
    x: 1.06132,
    strokeWidth: 0,
    fill: "#FFF"
  }, "\u4E2D"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.082d92e567fb39938428182e067bb217.svg";
export { ForwardRef as ReactComponent };